import { render, staticRenderFns } from "./drivingLicenseTypes.vue?vue&type=template&id=54f6dbce&"
import script from "./drivingLicenseTypes.vue.js?vue&type=script&lang=js&"
export * from "./drivingLicenseTypes.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports